import React, { useState } from 'react'
import { Collapse, Divider, Icon, IconButton, List, ListItem, ListItemIcon, ListItemText, SwipeableDrawer } from '@mui/material'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function MenuDrawer({ classes, onToggle, open, toggleCategoriesOpen }) {
	const navigate = useNavigate()
	const categories = useSelector(state => state.products.categories)
	const [searchText, setSearchText] = useState('')
	const shop = useSelector(state => state.shop)
	const isCatalogue = Number(shop.profiles.ueby_catalogue_only)

	const gotoShop = () => {
		onToggle(false)
		if (shop.profiles.ueby_categories_display_mode == 1) {
			toggleCategoriesOpen(true)
		} else {
			gotoPage('/shop')
		}
	}

	const gotoPage = (page) => {
		onToggle(false)
		navigate(page)
	}
	return (<SwipeableDrawer
		anchor="left"
		open={open}
		onClose={() => onToggle(false)}
		onOpen={() => onToggle(true)}
		PaperProps={{
			sx: (theme) => ({
				backgroundColor: theme.palette.primary.main,
				width: '100%',
				maxWidth: 375,
				'& .close': {
					float: 'right',
					'& *': {
						color: theme.palette.getContrastText(theme.palette.primary.main),
					}
				},
				'& .menu': {
					'& *': {
						color: theme.palette.getContrastText(theme.palette.primary.main),
					}
				},
			})
		}}
	>
		<List component="nav" aria-label="main mailbox folders">
			<div className="close">
				<IconButton aria-label="chiudi" component="span" onClick={() => { onToggle(false) }}>
					<Icon>cancel</Icon>
				</IconButton>
			</div>

			{shop.shop_mode_enabled == '1' &&
				<>
					<ListItem button className="menu" onClick={() => gotoPage('/condizioniDiVendita')}>
						<ListItemIcon>
							<Icon>text_snippet</Icon>
						</ListItemIcon>
						<ListItemText primary="Condizioni di vendita" />
					</ListItem>
					<Divider />

					{Number(shop.payments_menu) == 1 && <React.Fragment>
						<ListItem button className="menu" onClick={() => gotoPage('/metodiPagamento')}>
							<ListItemIcon>
								<Icon>credit_card</Icon>
							</ListItemIcon>
							<ListItemText primary="Metodi di pagamento" />
						</ListItem>
						<Divider />
					</React.Fragment>}

					{Number(shop.shipping_menu) == 1 && <React.Fragment>
						<ListItem button className="menu" onClick={() => gotoPage('/metodiConsegna')}>
							<ListItemIcon>
								<Icon>moped</Icon>
							</ListItemIcon>
							<ListItemText primary="Consegna della merce" />
						</ListItem>
						<Divider />
					</React.Fragment>}

					{Number(shop.returns_menu) == 1 && <React.Fragment>
						<ListItem button className="menu" onClick={() => gotoPage('/resiRimborsi')}>
							<ListItemIcon>
								<Icon>undo</Icon>
							</ListItemIcon>
							<ListItemText primary="Resi e rimborsi" />
						</ListItem>
						<Divider />
					</React.Fragment>}
				</>
			}

			<ListItem button className="menu" onClick={() => gotoPage('/informativaPrivacy')}>
				<ListItemIcon>
					<Icon>security</Icon>
				</ListItemIcon>
				<ListItemText primary="Informativa sulla privacy" />
			</ListItem>
			<Divider />

			<ListItem button className="menu" onClick={() => gotoPage('/negozio')}>
				<ListItemIcon>
					<Icon>info</Icon>
				</ListItemIcon>
				<ListItemText primary="Informazioni sul negozio" />
			</ListItem>
			<Divider />

			{shop.shop_mode_enabled == '1' && Number(shop.restaurant_allergens_menu) == 1 && <React.Fragment>
				<ListItem button className="menu" onClick={() => gotoPage('/allergeniRistorante')}>
					<ListItemIcon>
						<Icon>no_meals</Icon>
					</ListItemIcon>
					<ListItemText primary="Tabella degli allergeni" />
				</ListItem>
				<Divider />
			</React.Fragment>}

			<ListItem button className="menu" onClick={() => window.open('https://www.ueby.it')}>
				<ListItemIcon>
					<Icon>support_agent</Icon>
				</ListItemIcon>
				<ListItemText
					primary="Realizzato con la piattaforma UEBY"
				/>
			</ListItem>
			<Divider />
		</List>
	</SwipeableDrawer>)
}

export default withStyles(style)(MenuDrawer)
